module.exports = __webpack_public_path__ + "static/brooch_of_shielding-6fc67225d7ce8bbe4c18c58283e7ab7e.jpeg";